import Query from 'library/util/query';

const CareerClusterClustersQuery = async () => (
  await Query(`
    {
    career_clusters_survey_clusters {
      title
      description
      id
    }
  }
  `)
);

export default CareerClusterClustersQuery;
